import "./FooterStyles.css";
import logo from "../../assets/images/LogoGreenWithX.png";
const Footer = () => {
  return (
    <section className="footer_section">
      <div className="wLayoutBlockContainer footerSubDiv container wContainer">
        <div className="content_wrapper isFooter">
          <div className="footer_nav">
            <a
              href="index.html"
              aria-current="page"
              className="wnavbrand wCurrent"
            >
              <img loading="lazy" src={logo} alt="" className="logo" />
            </a>

            <div className="hflex is12Gap">
              <a
                href="https://www.linkedin.com/company/aiiro-ai/"
                target="_blank"
                rel="noreferrer"
                className="social_link wInlineBlock"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="100%"
                  viewBox="0 0 28 28"
                  fill="none"
                  className="social_icon"
                >
                  <g clipPath="url(#clip0_2646_40)">
                    <path
                      d="M25.4672 0H2.53283C1.134 0 0 1.134 0 2.53283V25.4671C0 26.866 1.134 28 2.53283 28H25.4671C26.866 28 28 26.866 28 25.4671V2.53283C28 1.134 26.866 0 25.4672 0ZM8.66439 24.177C8.66439 24.5841 8.3344 24.9141 7.9273 24.9141H4.78969C4.38259 24.9141 4.0526 24.5841 4.0526 24.177V11.0243C4.0526 10.6172 4.38259 10.2872 4.78969 10.2872H7.9273C8.3344 10.2872 8.66439 10.6172 8.66439 11.0243V24.177ZM6.35849 9.04737C4.71228 9.04737 3.37774 7.71283 3.37774 6.06662C3.37774 4.42041 4.71228 3.08586 6.35849 3.08586C8.0047 3.08586 9.33925 4.42041 9.33925 6.06662C9.33925 7.71283 8.00478 9.04737 6.35849 9.04737ZM25.0615 24.2364C25.0615 24.6107 24.758 24.9141 24.3837 24.9141H21.0169C20.6426 24.9141 20.3391 24.6107 20.3391 24.2364V18.067C20.3391 17.1467 20.6091 14.0341 17.934 14.0341C15.859 14.0341 15.4381 16.1646 15.3536 17.1207V24.2364C15.3536 24.6107 15.0502 24.9141 14.6759 24.9141H11.4195C11.0453 24.9141 10.7418 24.6107 10.7418 24.2364V10.9649C10.7418 10.5907 11.0453 10.2872 11.4195 10.2872H14.6759C15.0501 10.2872 15.3536 10.5907 15.3536 10.9649V12.1124C16.123 10.9577 17.2665 10.0665 19.7011 10.0665C25.0923 10.0665 25.0615 15.1033 25.0615 17.8707V24.2364Z"
                      fill="currentColor"
                    ></path>
                  </g>
                  <defs>
                    <clippath id="clip0_2646_40">
                      <rect width="28" height="28" fill="currentColor"></rect>
                    </clippath>
                  </defs>
                </svg>
              </a>
            </div>
          </div>
          <div className="divider"></div>
          <div className="hFlex is40Gap lowerFooter">
            <a
              href="https://www.aiiro.ai/privacy-policy"
              target="_blank"
              rel="noreferrer"
              className="privacyLink"
            >
              Privacy Policy
            </a>
            <a
              href="https://www.aiiro.ai/terms-of-use"
              target="_blank"
              rel="noreferrer"
              className="privacyLink"
            >
              Terms of Use
            </a>
            <a
              href="https://www.aiiro.ai/aiiro-cookies-policy"
              target="_blank"
              className="privacyLink"
              rel="noreferrer"
            >
              Cookies Policy
            </a>
            <div className="textSecondary isSemiBold">
              © {new Date().getFullYear()} aiiro. All rights reserved.
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Footer;
